import { z } from "zod"

import { entityIdSchema } from "./identifiers.js"
import { payrollInputKindV1Schema } from "./payroll-input-v1.js"

const inputReferenceSchema = z.object({
  inputId: entityIdSchema,
  inputVersion: z.number().int().positive(),
}).strict()

export const payrollExternalExportCreateV1Schema = z.object({
  exportId: entityIdSchema,
  activationId: entityIdSchema,
  packId: entityIdSchema,
  packVersion: z.number().int().positive(),
  asOfDate: z.iso.date(),
  countryCode: z.string().regex(/^[A-Z]{2}$/),
  stateCode: z.string().regex(/^[A-Z0-9]{2,3}$/),
  localityCode: z.string().regex(/^[A-Z0-9_-]{2,32}$/),
  inputs: z.array(inputReferenceSchema).min(1).max(500),
}).strict().superRefine((value, context) => {
  if (new Set(value.inputs.map((item) => item.inputId)).size !== value.inputs.length) {
    context.addIssue({ code: "custom", path: ["inputs"], message: "Inputs must be unique." })
  }
})

export const payrollExternalExportRowV1Schema = z.object({
  inputId: entityIdSchema,
  inputVersion: z.number().int().positive(),
  workShiftId: entityIdSchema,
  sourceShiftVersion: z.number().int().positive(),
  workerId: entityIdSchema,
  relationshipId: entityIdSchema,
  kind: payrollInputKindV1Schema,
  minutes: z.number().int().positive().nullable(),
  jobReference: z.string().min(1).max(120).nullable(),
  amountMinor: z.number().int().positive().nullable(),
  currency: z.string().regex(/^[A-Z]{3}$/).nullable(),
}).strict()

export const payrollExternalExportResultV1Schema = z.object({
  entityType: z.literal("payroll_external_export"),
  entityId: entityIdSchema,
  state: z.literal("created"),
  version: z.literal(1),
  exportVersion: z.literal(1),
  reasonCode: z.string().regex(/^[a-z][a-z0-9_]{2,63}$/),
  finalizationAllowed: z.literal(false),
  rowCount: z.number().int().positive(),
  rows: z.array(payrollExternalExportRowV1Schema).min(1).max(500),
  fileName: z.string().regex(/^payroll-external-[0-9a-f-]+\.csv$/),
  csvContent: z.string().min(1).max(1_000_000),
  contentFingerprint: z.string().regex(/^[a-f0-9]{64}$/),
  provenanceIncluded: z.literal(true),
}).strict()

export type PayrollExternalExportRowV1 = z.infer<
  typeof payrollExternalExportRowV1Schema
>
